<template>
  <!-- 项目公告 -->
  <div class="main">
    <!-- 标题行 -->
    <div class="titleRow">
      <div class="title">
        <el-divider direction="vertical"></el-divider>
        <span>项目公告</span>
      </div>

      <div class="options">
        <span :class="{'spanDisabled': !currentPrjId}" @click="enterProjectNotice">更多<i
          class="el-icon-d-arrow-right"></i></span>
      </div>
    </div>

    <!-- 搜索行 -->
    <div class="searchRow">
      <div class="daterange">
        <span>日期：</span>
        <el-date-picker v-model="daterange" type="daterange" size="small" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" clearable @change="noticeFilter">
        </el-date-picker>
      </div>
      <el-input v-model="keyword" placeholder="请输入标题、摘要" size="small" maxlength="20" clearable
        @keyup.enter.native="noticeFilter" @clear="noticeFilter">
        <el-button slot="append" icon="el-icon-search" class="searchBtn" @click="noticeFilter"></el-button>
      </el-input>
    </div>

    <!-- 展示区 -->
    <div class="showArea">
      <!-- 暂无公告 -->
      <div v-if="noticeList.length == 0" class="notNotice">
        <el-image style="width: 280px; height: 220px" :src="notNotice" fit="contain"></el-image>
      </div>

      <!-- 有公告 -->
      <template v-if="noticeList.length">
        <!-- 列表 -->
        <div class="noticeListSlider">
          <div v-for="notice in noticeList" :key="notice.noticeId" class="noticeItem" @click="openSeeDialog(notice)">
            <div class="itemLeft">
              <el-image :src="projectNotice" style="width: 46px; height: 46px"></el-image>
            </div>
            <div class="itemRight">
              <div class="rightTop">
                <span class="name" :title="notice.noticeTitle">{{ notice.noticeTitle }}</span>
                <span class="time">{{ notice.createTime }}</span>
              </div>
              <div class="rightBottom">
                <span class="content">{{ notice.noticeAbstract }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 分页 -->
        <el-pagination v-if="page.total > 0" background layout="prev, pager, next, jumper"
          :current-page.sync="page.pageNum" :page-size="page.pageSize" :total="page.total"
          @current-change="getNoticeList">
        </el-pagination>
      </template>
    </div>

    <!-- 查看弹框 -->
    <el-dialog v-dialogDrag title="查看" :visible.sync="AnnoundialogLookVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" width="924px" class="noticeEditialog">
      <p class="noticeTitle">{{ TableRow.noticeTitle }}</p>
      <p class="createTime">
        <span style="margin-right:25px">{{ TableRow.createTime }}</span>
        <span>{{ TableRow.operateUserName }}</span>
      </p>
      <p class="noticeAbstract">{{ TableRow.noticeAbstract }}</p>
      <p class="noticeCon" v-html="TableRow.content"></p>
      <!-- 文件 -->
      <div v-if="TableRow.files&&TableRow.files.length" class="enclosure">
        <span>附件:</span>
        <el-table :data="TableRow.files" :show-header="false" max-height="200px"
          @row-click="rowClick">
          <el-table-column label="名称" prop="fileName"></el-table-column>
          <el-table-column label="操作" fixed="right" width="120px">
            <template slot-scope="scope">
              <span class="midd-table">
                <i class="el-icon-download" title="下载" @click.stop="uploadRowType(scope.$index, TableRow.files)" />
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="AnnoundialogLookVisible=false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { downloadUrltoken } from "@/CommonDP/utils";
import { filePreviewV1 } from "@/CommonDP/utils/docPublic";
import workProjectBoardService from "@/CommonDP/service/workProjectBoard-service";
import prjNoticeService from "@/CommonDP/service/prjNotice-service";
import moment from "moment";

export default {
  components: {},
  props: ["currentPrjId"],
  data() {
    return {
      notNotice: require("@/CommonDP/assets/workProjectBoard/notNotice.png"), // 暂无公告
      projectNotice: require("@/CommonDP/assets/workProjectBoard/projectNotice.png"), // 项目公告
      daterange: [], // 日期范围
      keyword: "", // 搜索关键字
      page: {
        pageNum: 1,
        pageSize: 20,
        total: 0
      }, // 分页
      noticeList: [], // 公告数据
      AnnoundialogLookVisible: false, // 查看公告弹框
      TableRow: {
        files: []
      } // 当前公告
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    }),

    // 开始时间
    startDate() {
      if (this.daterange && this.daterange.length > 0) {
        return moment(this.daterange[0]).format("YYYY-MM-DD") + " 00:00:00";
      } else {
        return "";
      }
    },
    // 结束时间
    endDate() {
      if (this.daterange && this.daterange.length > 1) {
        return moment(this.daterange[1]).format("YYYY-MM-DD") + " 23:59:59";
      } else {
        return "";
      }
    }
  },
  watch: {
    currentPrjId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getNoticeList();
        }
      }
    }
  },
  mounted() {},
  methods: {
    // 获得项目公告列表
    async getNoticeList() {
      const params = {
        enterpriseId: this.enterpriseId,
        prjId: this.currentPrjId,
        keyWord: this.keyword,
        isPublish: 1, // 启用
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        startTime: this.startDate,
        endTime: this.endDate
      };
      const res = await workProjectBoardService.getNoticeList(params);
      this.noticeList = res.data;
      this.page.total = res.totalCount;
    },
    // 公告筛选
    noticeFilter() {
      this.page.pageNum = 1;
      this.getNoticeList();
    },

    // 打开查看弹框
    async openSeeDialog(row) {
      const res = await prjNoticeService.prjNoticeGet(row.noticeId);
      this.TableRow = res.data;
      this.AnnoundialogLookVisible = true;
    },
    // 附件点击，预览
    rowClick(row) {
      const { status = "1", fileId, fileVersion: versionId = 1, parentId = "", fileType } = row;
      const data = { status, fileId, versionId, parentId, fileType };
      filePreviewV1(data, this.tableData1);
    },
    // 附件下载
    uploadRowType(index, row) {
      const prjId = this.currentPrjId;
      const fileId = row[index].fileId;
      window.location = downloadUrltoken(prjId, fileId);
    },

    // 进入项目公告
    enterProjectNotice() {
      this.$emit("enterProjectFront");
      // this.$router.push("/mainMg/projectMg/prjNotice");
      this.$router.push("/project-prjNotice");
    }
  }
};
</script>

<style lang='scss' scoped>
@import "../../../../../styles/noticeEditialog.css";
.main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .titleRow {
    width: 100%;
    border-bottom: 1px solid #e5e8f1;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      display: flex;
      align-items: center;

      .el-divider {
        width: 3px;
        height: 15px;
        margin-left: 0;
        background: var(--theme-color);
      }

      span {
        font-family: "PingFang SC";
        font-weight: 700;
        font-size: 16px;
        color: var(--key-color);
      }
    }

    .options {
      span {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 14px;
        color: var(--common-color);
        cursor: pointer;

        display: flex;
        align-items: center;
      }
      span:hover {
        color: var(--theme-color);
      }

      .spanDisabled {
        pointer-events: none;
      }
    }
  }

  .searchRow {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .daterange {
      width: 320px;
      display: flex;
      align-items: center;

      span {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        color: var(--common-color);
        white-space: nowrap;
      }
    }

    .el-input {
      width: 245px;
    }

    .searchBtn {
      padding: 9px 13px !important;
      color: #ffffff;
    }
    .searchBtn:hover {
      color: #ffffff !important;
    }

    /deep/ .el-input-group__append {
      text-align: center;
      background: var(--theme-color);
    }
    /deep/ .el-input-group__append:hover {
      opacity: 0.8;
    }

    /deep/ .el-range-separator {
      width: max-content;
      color: var(--common-color);
    }
  }

  .showArea {
    width: 100%;
    height: 1px;
    flex-grow: 1;
    padding: 0 var(--big-space) var(--middle-space);

    .notNotice {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .noticeListSlider {
      width: 100%;
      height: calc(100% - 42px);
      overflow-y: auto;
    }

    .el-pagination {
      float: right;
      padding-top: var(--middle-space);
    }
  }
}

.noticeItem {
  min-height: 50px;
  padding: 5px;
  margin: 5px 0 10px;
  display: flex;
  cursor: pointer;

  .itemLeft {
    padding-right: 10px;
  }

  .itemRight {
    width: calc(100% - 50px);
    padding-right: 5px;

    .rightTop {
      height: 20px;
      font-family: "PingFang SC";
      display: flex;
      justify-content: space-between;
      align-items: baseline;

      .name {
        max-width: calc(100% - 225px);
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        color: var(--key-color);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .time {
        padding-left: 30px;
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;
        color: var(--common-color);
        white-space: nowrap;
        flex-shrink: 0;
      }
    }

    .rightBottom {
      min-height: 20px;
      padding-top: 2px;

      .content {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;
        color: var(--common-color);

        overflow: hidden;
        -webkit-line-clamp: 2;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
    }
  }
}
.noticeItem:hover {
  box-shadow: 0px 0px 10px rgba(71, 119, 231, 0.3);
}

.noticeEditialog {
  /deep/ .el-dialog {
    min-width: 420px;
    .el-dialog__body {
      padding: 18px !important;
      .noticeTitle {
        text-align: center;
        font-size: 18px;
        color: var(--key-color);
      }
      .createTime {
        text-align: center;
        margin-top: 9px;
        span {
          color: #acb5c9;
          font-size: 14px;
        }
      }
      .noticeAbstract {
        color: var(--key-color);
        font-size: 14px;
        margin-top: 16px;
      }
      .noticeCon {
        margin-top: 16px;

        p {
          font-size: 14px !important;
        }
      }
      .enclosure {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 20px;
        span {
          margin-right: 10px;
          color: var(--key-color);
          font-size: 14px;
        }
      }
    }
    .el-dialog__footer {
      text-align: center;
    }
  }
}
</style>
